var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 35,
    viewBox: "0 0 31 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.8496C17.7437 16.8496 19.5625 15.0308 19.5625 12.7871C19.5625 10.5435 17.7437 8.72461 15.5 8.72461C13.2563 8.72461 11.4375 10.5435 11.4375 12.7871C11.4375 15.0308 13.2563 16.8496 15.5 16.8496Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4502 28.3952C8.6787 19.4138 22.3222 19.4138 23.5507 28.3952",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3125 23.6747V11.3247C29.3117 10.7841 29.1698 10.2531 28.9008 9.78424C28.6317 9.31538 28.2448 8.92493 27.7785 8.65153L17.034 2.47653C16.5681 2.20598 16.0388 2.06348 15.5 2.06348C14.9612 2.06348 14.432 2.20598 13.966 2.47653L3.22151 8.65153C2.75352 8.92306 2.36533 9.3131 2.09603 9.78238C1.82673 10.2517 1.68583 10.7836 1.68751 11.3247V23.6779C1.68856 24.2182 1.83064 24.7489 2.09968 25.2174C2.36872 25.686 2.75542 26.0761 3.22151 26.3494L13.966 32.5244C14.432 32.795 14.9612 32.9375 15.5 32.9375C16.0388 32.9375 16.5681 32.795 17.034 32.5244L27.7785 26.3494C28.2467 26.0777 28.6351 25.6875 28.9044 25.2179C29.1737 24.7483 29.3145 24.216 29.3125 23.6747Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileExternal);
export default __webpack_public_path__ + "static/media/icon-profile-external.c269efffcd753b148d5908d91974fcda.svg";
export { ForwardRef as ReactComponent };